import { Button, Card, Divider, Flex, Tooltip, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTerminal } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { ExecutionDetailsModal } from '@features/quotations/components/ExecutionDetailsModal';
import { useModal } from '@shared/hooks/useModal';
import { ConnectionTypeTag } from '@shared/components/ConnectionTypeTag';
import { InsuranceCarrierLogo } from 'Components/commonComponents/InsuranceCarrierLogo';
import ProgressBarLoading from 'Components/commonComponents/ProgressBarLoading';

const { Text, Title } = Typography;

/**
 * Card de package in progress (pending/started) o dummy de carga sin package
 * (solo aseguradora, si el package aún no está en Redux).
 */
const InsuranceCarrierPackageDummyCard = ({
  insuranceCarrier,
  insurancePackage = null,
}) => {
  const isSupportUser = useSelector((state) => state.initialData.user?.isSupportUser ?? false);
  const executionDetailsModal = useModal();

  const canViewExecutionDetails = isSupportUser && !!insurancePackage?.id;
  const hasPackageDetail = !!insurancePackage?.package_detail;

  return (
    <Card styles={{ body: { height: '100%' } }}>
      {canViewExecutionDetails && (
        <>
          <Tooltip
            title={(
              <Flex vertical>
                <Text style={{ color: 'inherit' }}>
                  Ver detalles de ejecución
                </Text>
                <Text style={{ color: 'inherit', fontSize: '0.8em' }}>
                  Disponible solo para usuarios de soporte
                </Text>
              </Flex>
            )}
            placement='left'
          >
            <Button
              color='primary'
              variant='text'
              shape='circle'
              size='large'
              icon={<FontAwesomeIcon icon={faTerminal} />}
              onClick={executionDetailsModal.open}
              style={{ position: 'absolute', top: 4, right: 4 }}
            />
          </Tooltip>
          <ExecutionDetailsModal
            open={executionDetailsModal.isOpen}
            onClose={executionDetailsModal.close}
            quotationId={insurancePackage.quotation}
            quotationInsuranceCarrierId={insurancePackage.id}
          />
        </>
      )}
      <Flex vertical gap={8} justify='center' align='center' style={{ height: '100%' }}>
        <InsuranceCarrierLogo name={insuranceCarrier.name} logoUrl={insuranceCarrier.logo_url} size='lg' />
        <img src='https://res.cloudinary.com/compara/image/upload/v1569616070/assets/card/shadow.svg' alt='Box insurance carrier logo' style={{ height: '11px', width: '100%' }} />
        {hasPackageDetail && (
          <Title level={5} ellipsis={{ rows: 2, tooltip: true }} style={{ margin: 0 }}>{insurancePackage.package_detail}</Title>
        )}
        <Flex
          vertical
          justify='center'
          align='center'
          style={{
            width: '100%',
            marginTop: hasPackageDetail ? 8 : 0,
          }}
        >
          <Text strong style={{ fontSize: '1.1em', lineHeight: 1 }}>Cotizando</Text>
          <Divider size='small' />
          <ProgressBarLoading infinite />
          {/* TODO: mostrar porcentaje de progreso cuando esté disponible */}
          {/* <p>{insurancePackage?.percent_progress}%</p> */}
        </Flex>
      </Flex>
      {insurancePackage?.source_type && (
        <ConnectionTypeTag
          connectionType={insurancePackage.source_type}
          testMode={insurancePackage.test_mode}
          tooltip={(title) => `Cotizando por ${title}`}
          style={{ position: 'absolute', bottom: -8, right: -8 }}
        />
      )}
    </Card>
  );
};

export default InsuranceCarrierPackageDummyCard;
